// Coordinate formatting helpers for map interactions (right-click "Copy
// coordinates", POI labels, share dialogs, etc.).

/**
 * formatClipboardCoords — turns a { lng, lat } pair into the text the user
 * gets when they pick "Copy coordinates" from a map context menu.
 *
 * TODO(user): pick the format. Things to weigh:
 *   - Precision. 6 decimal places ≈ 11 cm at the equator; 5 ≈ 1 m. GPS
 *     fix accuracy on staff phones is ~5 m, so 5 dp is honest.
 *   - Order. Google Maps + Apple Maps both expect "lat,lng" (no space)
 *     when you paste into the search box. Most GIS tools also accept
 *     "lat, lng". A label like "26.31802, 50.21934" is human-readable
 *     but not paste-into-Maps friendly.
 *   - RTL. If the value can be copied into an Arabic-language note, the
 *     comma should be a regular ASCII ',' — Arabic '،' breaks tools that
 *     parse the string.
 *
 * Replace this body with the format you want. Keep the signature.
 */
export function formatClipboardCoords({ lat, lng }) {
  if (lat == null || lng == null) return '';
  // Placeholder — paste-compatible with Google/Apple Maps search.
  return `${lat.toFixed(5)},${lng.toFixed(5)}`;
}

export async function copyCoordsToClipboard({ lat, lng }) {
  const text = formatClipboardCoords({ lat, lng });
  if (!text || !navigator.clipboard) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
